import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTime } from 'react-intl';
import MyFormattedDate from './MyFormattedDate';

const MyFormattedDateTime = ({ value }) => (value
  ? (
    <>
      <MyFormattedDate
        value={value}
      />
      {
        ' '
      }
      <FormattedTime
        value={value}
      />
    </>
  ) : '');

MyFormattedDateTime.propTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
};

MyFormattedDateTime.defaultProps = {

};

export default MyFormattedDateTime;
